<template>
    <div>
        <div class="bg">
            <pointLoading v-show="loading"></pointLoading>
            <div class="topBox"></div>
            <div class="header">
                <div class="header-title">
                    <!-- <img @click="goContractPoint" v-if="$route.query.backgroundColor == 'day'" src="../assets/images/contractPoint/arrow-moon1.png">
                    <img @click="goContractPoint" v-else src="../assets/images/contractPoint/arrow-day1.png"> -->
                    <img :class="{ mirrorRotateLevel: isDirection }" @click="$router.go(-1)" v-if="$route.query.backgroundColor == 'day'" src="../assets/images/contractPoint/arrow-moon1.png">
                    <img :class="{ mirrorRotateLevel: isDirection }" @click="$router.go(-1)" v-else src="../assets/images/contractPoint/arrow-day1.png">
                    <div>{{$t('9100013')}}</div>
                </div>
                <div class="header-icon">
                    <svg @click="popupShow = true" class="icon arrow" aria-hidden="true">
                        <use xlink:href="#icon-rili"></use>
                    </svg>
                    <svg @click="typeShow = true" class="icon arrow icon_2" aria-hidden="true">
                        <use xlink:href="#icon-shaixuan"></use>
                    </svg>
                </div>
            </div>
            <div class="content">
                <div class="content-title">
                    <div>{{$t('9100050')}}</div>
                    <div>{{$t('300421')}}</div>
                    <div>{{$t('9100021')}}</div>
                </div>
                <div>
                    <div class="content-list" v-for="(item,index) in pointsDetailsList" :key="index">
                        <div>{{parseTime(item.createTime)}}</div>
                        <div>{{getTypeDescription(item.pointType)}}</div>
                        <div>{{item.pointAmount}}</div>
                    </div>
                    <van-empty v-if="total == 0" class="custom-image" :description="$t('300108')">
                        <svg slot="image" class="icon emptyIcon" aria-hidden="true">
                            <use :xlink:href="$route.query.backgroundColor == 'day' ? '#icon-jilu1' : '#icon-zanwujilu'"></use>
                        </svg>
                    </van-empty>
                </div>

            </div>
        </div>

        <!-- date -->
        <van-popup v-model="popupShow" class="datePopup" position="bottom">
            <div class="popip_header">
                <div class="popip_title">{{popupType  === 'start' ? $t('9100051') : $t('9100052')}}</div>
                <div class="popip_close">
                    <svg @click="popupShow = false" class="icon arrow" aria-hidden="true">
                        <use xlink:href="#icon-guanbi1"></use>
                    </svg>
                </div>
            </div>
            <div class="date_box">
                <div class="date_box_item" :class="{cur: popupType  === 'start'}" @click="popupType = 'start'">{{parseTime(searchForm.startDate).split(' ')[0]}}</div>
                <div class="pad">{{$t('9100053')}}</div>
                <div class="date_box_item" :class="{cur: popupType  === 'end'}" @click="popupType = 'end'">{{parseTime(searchForm.endDate).split(' ')[0]}}</div>

            </div>
            <van-datetime-picker v-if="popupType  === 'start'" v-model="searchForm.startDate" type="date" :show-toolbar="showToolbar" :min-date="minDate" :max-date="maxDate" />
            <van-datetime-picker v-if="popupType  === 'end'" v-model="searchForm.endDate" type="date" :show-toolbar="showToolbar" :min-date="minDate" :max-date="maxDate" />
            <div class="date_btn">
                <div class="cancel" @click="popupShow = false">{{$t('300111')}}</div>
                <div class="confirm" @click="confirmTime">{{$t('300287')}}</div>
            </div>
        </van-popup>

        <!-- type -->
        <van-popup v-model="typeShow" class="typePopup" position="bottom">
            <div class="header">
                <div class="typeText">{{$t('9100054')}}</div>
                <svg @click="typeShow = false" class="icon arrow" aria-hidden="true">
                    <use xlink:href="#icon-guanbi1"></use>
                </svg>
            </div>
            <div class="content">
                <div class="content-item" v-for="(item, index) in typeList" :key="index" @click="toggleSelected(item)">
                    <div class="text">{{item.text}}</div>
                    <div class="icon" v-show="item.selected">
                        <img src="../assets/images/contractPoint/tohook.png">
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { Swipe, SwipeItem, Empty } from 'vant'
    import { parseTime } from "../utils/index";
    import {
        pointsDetails
    } from '../api/contractPoint.js'
    import pointLoading from '../compontents/pointLoading.vue'
    export default {
        name: 'pointsDetails',
        components: {
            VanSwipe: Swipe,
            VanSwipeItem: SwipeItem,
            vanEmpty: Empty,
            pointLoading,
        },
        data() {
            return {
                loading: false,
                pointLoading: false,
                showToolbar: false,
                popupShow: false,
                typeShow: false,
                popupType: 'start', //start || end
                minDate: new Date(2020, 0, 1),
                maxDate: new Date(2025, 10, 1),
                typeList: [
                    { text: this.$t('9100042'), selected: !this.$route.query.type, value: "" },
                    { text: this.$t('9100006'), selected: this.$route.query.type === "1", value: "1" },
                    { text: this.$t('9100007'), selected: this.$route.query.type === "2", value: "2" },
                    { text: this.$t('9100008'), selected: this.$route.query.type === "3", value: "3" },
                    { text: this.$t('9100009'), selected: this.$route.query.type === "4", value: "4" },
                    { text: this.$t('9100010'), value: "6" }
                ],
                pointsDetailsList: [], //积分明细列表
                searchForm: {
                    pointType: '',
                    page: 1,
                    startDate: '',
                    endDate: '',
                    // pageSize: 10,
                },
                total: 0,
            }
        },
        created() {
            window.document.documentElement.setAttribute(
                'dir',
                this.isDirection ? 'rtl' : 'ltr'
            )
            if (this.$route.query.backgroundColor != '') {
                window.document.documentElement.setAttribute('data-theme', this.$route.query.backgroundColor === 'day' ? 'sunlight' : 'moon')
            } else {
                window.document.documentElement.setAttribute('data-theme', 'moon')
            }
            if (this.$route.query.type == 1) {
                this.searchForm.pointType = this.$route.query.type
                this.getPointsDetails()
            }
            else if (this.$route.query.type == 2) {
                this.searchForm.pointType = this.$route.query.type
                this.getPointsDetails()
            }
            else if (this.$route.query.type == 3) {
                this.searchForm.pointType = this.$route.query.type
                this.getPointsDetails()
            }
            else if (this.$route.query.type == 4) {
                this.searchForm.pointType = this.$route.query.type
                this.getPointsDetails()
            } else {
                this.getPointsDetails()
            }
            if (!this.searchForm.startDate) {
                const currentDate = new Date();
                const sevenDaysLater = new Date(currentDate.getTime() - 7 * 24 * 60 * 60 * 1000); // 当前时间加上七天的毫秒数
                this.searchForm.startDate = new Date(sevenDaysLater.getFullYear(), sevenDaysLater.getMonth(), sevenDaysLater.getDate(), 0, 0, 0);
                this.searchForm.endDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 0, 0, 0);
                // const currentDate = new Date();
                // const sevenDaysLater = new Date(currentDate.getTime() - 7 * 24 * 60 * 60 * 1000); // 七天前的时间
                // this.searchForm.startDate = sevenDaysLater.getTime(); // 七天前的时间戳
                // this.searchForm.endDate = currentDate.getTime(); // 当前时间的时间戳
            }
        },
        mounted() {

        },
        beforeDestroy() {

        },
        computed: {
            ...mapGetters(['token', 'isDirection', 'language']),
            getTypeDescription() {
                return function (type) {
                    const typeMap = {
                        1: this.$t('9100006'),  //9100006
                        2: this.$t('9100007'),  //9100007
                        3: this.$t('9100008'),  //9100008
                        4: this.$t('9100009'),  //9100009
                        5: this.$t('9100009'),  //9100009
                        6: this.$t('9100010'),  //9100010
                    };
                    return typeMap[type] || '--';
                };
            }
        },
        watch: {

        },
        methods: {
            confirmTime() {
                console.log(parseTime(this.searchForm.startDate), 'this.startDated1');
                console.log(parseTime(this.searchForm.endDate).split(' ')[0], 'this.endDate1');
                console.log(parseTime(new Date().getTime()));
                this.getPointsDetails()
                this.popupShow = false
            },
            parseTime(time, type) {
                if (time) {
                    return parseTime(time, type)
                } else {
                    return '--'
                }
            },
            //积分明细
            getPointsDetails() {
                this.loading = true
                console.log(this.searchForm.startDate,'this.searchForm.startDate--this.searchForm.startDate');
                // console.log(this.searchForm.endDate,'this.searchForm.endDate--this.searchForm.endDate');
                // 对 endDate 进行格式化，添加时间部分
                // let endDate = this.searchForm.endDate ? new Date(this.searchForm.endDate) : null;
                // if (endDate) {
                //     endDate.setHours(23, 59, 59);
                // }
                
                // console.log(endDate, 'this.searchForm.endDate (with time 23:59:59)');
                
                let params = {
                    pointType: this.searchForm.pointType,
                    // startTime: this.searchForm.startDate.getTime ? parseTime(this.searchForm.startDate.getTime()) : null,
                    // endTime: this.searchForm.endDate ? parseTime(this.searchForm.endDate.getTime()) : null,
                    // startTime: this.searchForm.startDate ? parseTime(this.searchForm.startDate) : null,
                    // endTime: this.searchForm.endDate ? parseTime(this.searchForm.endDate).split(' ')[0] + ' 23:59:59' : null,
                    startTimestamp: this.searchForm.startDate ? new Date(this.searchForm.startDate).getTime() : null,
                    // endTimestamp: this.searchForm.endDate ? new Date(this.searchForm.endDate).getTime() : null,
                    endTimestamp: this.searchForm.endDate ? new Date(new Date(this.searchForm.endDate).setHours(23, 59, 59)).getTime() : null,
                    page: this.searchForm.page,
                    pageSize: 9999,
                }
                pointsDetails(params).then((res) => {
                    console.log(res, '积分明细的res');
                    this.pointsDetailsList = res.data.items
                    this.total = res.data.total
                    this.loading = false
                })
            },
            // goContractPoint() {
            //     this.$router.push({
            //         path: '/contractPoint',
            //         query: {
            //             backgroundColor: this.$route.query.backgroundColor,
            //             isApp: this.$route.query.isApp,
            //             token: this.$route.query.token
            //         }
            //     });
            // },
            toggleSelected(selectedItem) {
                this.typeList.forEach(item => {
                    if (item === selectedItem) {
                        item.selected = true;
                    } else {
                        item.selected = false;
                    }
                });
                // console.log(selectedItem.value,'selectedItem-selectedItem');
                this.searchForm.pointType = selectedItem.value
                this.getPointsDetails()
                this.typeShow = false
            },
        }
    }
</script>
<style lang="scss" scoped>
    @import "../assets/css/variableName";
    @import "../style/mixin";
    //正常
    [dir="ltr"] {
        .header {
            &-title {
                div {
                    text-align: left;
                    margin-left: torem(3);
                }
            }
            &-icon {
                .icon_2 {
                    margin-left: torem(16);
                }
            }
        }
    }
    //镜像
    [dir="rtl"] {
        .header {
            &-title {
                div {
                    text-align: right;
                    margin-right: torem(3);
                }
            }
            &-icon {
                .icon_2 {
                    margin-right: torem(16);
                }
            }
        }
    }
</style>
<style lang="scss" scoped>
    @import "../assets/css/variableName";
    @import "../style/mixin";
    @import "../assets/css/mixin";
    .bg {
        @include background_color("background-color-4");
        max-height: 100%;
        min-height: 100vh;
        .topBox {
            height: torem(16);
            @include background_color("background-color-4");
        }
        .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: torem(19);
            padding: torem(16);
            &-title {
                display: flex;
                align-items: center;
                img {
                    width: torem(16);
                    height: torem(16);
                }
                div {
                    font-family: Lato, Lato;
                    font-weight: 600;
                    font-size: torem(16);
                    @include font_color("font-color-3");
                    line-height: torem(19);
                    letter-spacing: torem(1);
                    // text-align: left;
                    font-style: normal;
                    text-transform: none;
                    // margin-left: torem(3);
                }
            }
            &-icon {
                display: flex;
                justify-content: space-around;
                align-items: center;
                svg {
                    width: torem(16);
                    height: torem(16);
                }
                .icon_2 {
                    // margin-left: torem(16);
                }
            }
        }
        .content {
            margin: torem(16) torem(16) 0 torem(16);
            &-title {
                display: flex;
                align-items: center;
                height: torem(48);
                justify-content: space-between;
                div {
                    width: torem(126);
                    @include font_color("disale-color");
                }
            }
            &-list {
                display: flex;
                align-items: center;
                justify-content: space-between;
                div {
                    line-height: torem(18);
                    width: torem(126);
                    height: torem(48);
                    display: flex;
                    align-items: center;
                    @include font_color("font-color-3");
                    border-top: torem(1) solid;
                    border-bottom: torem(1) solid;
                    @include border_color("background-color-5");
                }
            }
        }
    }
</style>
<style lang="scss" scoped>
    @import "../assets/css/variableName";
    @import "../style/mixin";
    @import "../assets/css/mixin";
    .popip_header {
        display: flex;
        align-items: center;
        height: torem(16);
        margin-top: torem(24);
        margin-bottom: torem(28);
        justify-content: space-between;
        .popip_title {
            font-family: Lato, Lato;
            font-weight: 500;
            font-size: torem(16);
            @include font_color("font-color-3");
            line-height: torem(16);
            text-align: center;
            font-style: normal;
            text-transform: none;
        }
        .popip_close {
            svg {
                width: torem(12);
                height: torem(12);
            }
        }
    }
    .date_box {
        display: flex;
        align-items: center;
        height: 80px;
        padding: 0 20px;
        justify-content: center;
        overflow: hidden;
        margin-top: 10px;
        margin-bottom: 20px;

        .date_box_item {
            display: flex;
            align-items: center;
            justify-content: center;
            width: torem(155);
            height: torem(38);
            @include background_color("background-color-7");
            @include font_color("font-color-4");
            border-radius: torem(4);
            &.cur {
                // background: red
                @include font_color("font-color-3");
            }
        }
        .pad {
            padding: 0 torem(8);
            @include font_color("font-color-4");
        }
    }
    .van-popup--bottom {
        // height: torem(430);
        border-radius: torem(16) torem(16) 0 0;
        padding: 0px torem(16);
        @include background_color("background-color-8");
        // background-color: red;
    }
    /deep/ .van-picker__columns {
        width: torem(250);
    }
    .van-picker {
        display: flex;
        justify-content: center;
        // width: torem(149);
        @include background_color("background-color-8");
        height: torem(232);
        overflow: hidden;
        // background-color: red;
    }
    /deep/ .van-picker__mask {
        background-image: none !important;
    }
    //font
    .datePopup /deep/ .van-ellipsis {
        font-family: Lato, Lato;
        font-weight: 400;
        font-size: torem(14);
        // @include font_color("disale-color");
        line-height: torem(14);
        text-align: center;
        font-style: normal;
        text-transform: none;
    }
    .datePopup /deep/ .van-picker-column__item {
        @include font_color("disale-color");
    }
    //选中
    .datePopup
        /deep/
        .van-datetime-picker
        .van-picker-column__item.van-picker-column__item--selected {
        @include font_color("font-color-3");
    }
    .datePopup
        /deep/
        .van-datetime-picker
        .van-picker-column__item.van-picker-column__item--selected
        .van-ellipsis {
        font-family: Lato, Lato;
        font-weight: 400;
        font-size: torem(17);
        line-height: torem(16);
        text-align: center;
        font-style: normal;
        text-transform: none;
    }
    .date_btn {
        display: flex;
        justify-content: space-around;
        margin-top: torem(30);
        margin-bottom: torem(22);
        height: torem(40);
        // border: 1px solid red;
        div {
            width: torem(155);
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: torem(4);
        }
        .cancel {
            @include background_color("background-color-9");
            font-family: Lato, Lato;
            font-weight: 400;
            font-size: torem(16);
            @include font_color("disale-color");
            line-height: torem(16);
            text-align: left;
            font-style: normal;
            text-transform: none;
        }
        .confirm {
            background-color: #ffc72b;
            font-family: Lato, Lato;
            font-weight: 400;
            font-size: torem(16);
            color: #000922;
            line-height: torem(16);
            text-align: left;
            font-style: normal;
            text-transform: none;
        }
    }

    // 类型
    .typePopup {
        padding: 0 torem(16);
        .header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: torem(40);
            margin: torem(24) 0 torem(12) 0;
            .typeText {
                font-family: Lato, Lato;
                font-weight: 500;
                font-size: torem(16);
                @include font_color("font-color-3");
                line-height: torem(16);
                text-align: center;
                font-style: normal;
                text-transform: none;
            }
            svg {
                width: torem(12);
                height: torem(12);
            }
        }
        .content {
            margin-bottom: torem(24);
            &-item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: torem(46);
                .text {
                    font-family: Lato, Lato;
                    font-weight: 400;
                    font-size: torem(14);
                    @include font_color("font-color-3");
                    line-height: torem(14);
                    text-align: center;
                    font-style: normal;
                    text-transform: none;
                }
                .icon {
                    width: torem(26);
                    height: torem(22);
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }
    }
    .emptyIcon {
        display: flex;
        justify-content: center;
        width: torem(50);
        height: torem(50);
    }
    /deep/ .van-empty__image {
        width: torem(50);
        height: torem(50);
    }
    ::-webkit-scrollbar {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/view/pointsDetails.vue